{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"__experimental": true,
	"apiVersion": 3,
	"name": "core/tabs-menu",
	"title": "Tabs Menu",
	"description": "Display the tab buttons for a tabbed interface.",
	"version": "1.0.0",
	"category": "design",
	"textdomain": "default",
	"parent": [
		"core/tabs"
	],
	"allowedBlocks": [
		"core/tabs-menu-item"
	],
	"usesContext": [
		"core/tabs-list",
		"core/tabs-id",
		"core/tabs-activeTabIndex",
		"core/tabs-editorActiveTabIndex"
	],
	"attributes": {},
	"supports": {
		"html": false,
		"reusable": false,
		"lock": false,
		"dimensions": {
			"aspectRatio": false,
			"height": false,
			"minHeight": false,
			"width": false
		},
		"color": {
			"background": true,
			"text": true,
			"__experimentalDefaultControls": {
				"background": true,
				"text": true
			}
		},
		"typography": {
			"fontSize": true,
			"__experimentalFontFamily": true
		},
		"__experimentalBorder": {
			"color": true,
			"radius": true,
			"style": true,
			"width": true
		},
		"layout": {
			"default": {
				"type": "flex",
				"flexWrap": "nowrap",
				"orientation": "horizontal"
			},
			"allowSwitching": false,
			"allowVerticalAlignment": true,
			"allowJustification": true,
			"allowOrientation": true
		},
		"spacing": {
			"padding": true,
			"margin": true,
			"blockGap": true,
			"__experimentalDefaultControls": {
				"padding": true,
				"margin": true,
				"blockGap": true
			}
		}
	},
	"editorScript": "file:./index.js",
	"editorStyle": "file:./editor.css",
	"style": "file:./style-index.css"
}
